'use es6';

import { createTracker } from 'usage-tracker';
import events from 'simple-menus-lib/events.yaml';
const tracker = createTracker({
  events,
  properties: {
    namespace: 'advanced-menus'
  },
  lastKnownEventProperties: ['screen', 'subscreen']
});
export default tracker;